import { formatTime, getTime } from '@/utils/date';
import Mock from 'mockjs';

export function makeData(num) {
  return Mock.mock({
    runstate: 1,
    state: 0,
    networkMode: 1,
    mods: {
      mn606Mod: {
        humidity: 85,
        temp: 32,
        pumpRunstate: 1,
        pumpInstallState: 1,
        sensorDataList: [
          {
            name: '六氟化硫',
            unit: 'VOL%',
            unitName: 'VOL%',
            'value|0-10': 2,
            installState: 1,
            runstate: 1,
            faultState: 0,
            alarmState: 0
          },
          {
            name: '二氧化碳',
            unit: 'PPM',
            unitName: 'PPM',
            'value|0-5000': 1,
            installState: 1,
            runstate: 1,
            faultState: 0,
            alarmState: 0
          },
          {
            name: '氧气',
            unit: '%VOL',
            unitName: '%VOL',
            'value|18-23': 1,
            installState: 1,
            runstate: 1,
            faultState: 0,
            alarmState: 0
          },
          {
            name: '甲烷',
            unit: 'PPM',
            unitName: 'PPM',
            'value|0-100': 1,
            installState: 1,
            runstate: 1,
            faultState: 0,
            alarmState: 0
          },
          {
            name: '一氧化碳',
            unit: 'PPM',
            unitName: 'PPM',
            'value|0-50': 1,
            installState: 1,
            runstate: 1,
            faultState: 0,
            alarmState: 0
          },
          {
            name: '硫化氢',
            unit: 'PPM',
            unitName: 'PPM',
            'value|0-10': 2,
            installState: 1,
            runstate: 1,
            faultState: 0,
            alarmState: 0
          }
        ]
      }
    },
    beginTime: formatTime(new Date('2024-08-15 14:12:00').getTime() + num * getTime('m'))
  });
}
